module.exports = __webpack_public_path__ + "static/step_3_2-98192b40eda52aef2218d7b251601c76.svg";